import React from "react";

const Blogs = () => {
  return (
    <div className="container mt-5" style={{ height: "90vh" }}>
      <h3>
        1. What is <strong>Context API</strong> in React?
      </h3>
      <p>
        <strong> Answer:</strong> Context API is a react hook that enables
        sharing state, function and unique details throughout or part of a react
        application lightly and conveniently, most importantly it helps solving
        props drilling at all level of a app. Context API return two parts,
        provider and consumer. <strong>Provider</strong> - is parents which
        stores the component/s in need to share with its children.
        <strong> Consumer</strong>- surprisingly uses the state to store
        information. There are steps of using context API, firstly, declaring
        context method using createContext and then taking that created context
        to wrap the component tree to which values to be passed using value
        prop. Finally, accessing the passed value from any component by
        declaring useContext, context consumer.
      </p>

      <h3>
        2. What is <strong>Semantic Tag</strong>?
      </h3>
      <p>
        <strong>Answer:</strong> Semantic means something meaningful. Semantic
        elements are elements the meaning and action of which is easily
        perceivable. For example: "section" in HTML tells us its a part of a
        page, whereas, non-semantic tag like: div does not really clear what it
        is and what it does. Semantic elements= elements with a meaning.
        Semantic elements have a simple and clear meaning for both, the browser
        and the developer. In addition, semantic elements are SEO friendly,
        thus, helps website ranks in google efficiently through the structure
        and readability created by HTML5 semantic tags like: header, main,
        article, details, footer etc.
      </p>

    </div>
  );
};

export default Blogs;
